var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVirtualLayer2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5238 19.732C13.4921 19.879 13.4921 22.8186 15.5238 22.9656H20.331C20.9103 22.9656 21.4809 22.7494 21.9045 22.3603C23.3311 21.1153 22.5703 18.6253 20.6941 18.3919C20.0197 14.3369 14.1578 15.8759 15.5412 19.7406",
    fill: "#0068FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5238 19.732C13.4921 19.879 13.4921 22.8186 15.5238 22.9656H20.331C20.9103 22.9656 21.4809 22.7494 21.9045 22.3603C23.3311 21.1153 22.5703 18.6253 20.6941 18.3919C20.0197 14.3369 14.1578 15.8759 15.5412 19.7406",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6442 4.38917L17.4714 6.53281C18.8623 7.14644 18.8623 8.16099 17.4714 8.77462L12.6442 10.9183C12.096 11.1637 11.196 11.1637 10.6478 10.9183L5.82053 8.77462C4.42962 8.16099 4.42962 7.14644 5.82053 6.53281L10.6478 4.38917C11.196 4.14371 12.096 4.14371 12.6442 4.38917Z",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45312 11C4.45312 11.6873 4.96858 12.4809 5.59858 12.7591L11.154 15.23C11.5795 15.4182 12.0622 15.4182 12.4795 15.23L18.0349 12.7591C18.6649 12.4809 19.1804 11.6873 19.1804 11",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45312 15.0908C4.45312 15.8517 4.90312 16.539 5.59858 16.8499L11.154 19.3208C11.5795 19.509 12.0622 19.509 12.4795 19.3208",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualLayer2);
export default __webpack_public_path__ + "static/media/virtual-layer-2.ae0c3ef19a656ce0cb5a34b223a574ba.svg";
export { ForwardRef as ReactComponent };